import Constants from 'expo-constants';
import { Platform } from 'react-native';
import { supabaseAnon } from './supabase';
import { logger } from './logger';

export type BundledAppVersions = {
  web: string;
  ios: string;
  android: string;
};

export function getBundledAppVersion(): string {
  const v = Constants.expoConfig?.extra?.appVersions as Partial<BundledAppVersions> | undefined;
  const key: keyof BundledAppVersions =
    Platform.OS === 'ios' ? 'ios' : Platform.OS === 'android' ? 'android' : 'web';
  const fromConfig = v?.[key];
  if (fromConfig) return fromConfig;
  return Constants.expoConfig?.version ?? '0.0.0';
}

export type AppVersionPlatform = 'web' | 'ios' | 'android';

export interface AppVersionInfo {
  current_version: string;
  min_version: string;
  release_notes: string | null;
}

export function getAppVersionPlatform(): AppVersionPlatform {
  if (Platform.OS === 'ios') return 'ios';
  if (Platform.OS === 'android') return 'android';
  return 'web';
}

export async function fetchAppVersion(platform: AppVersionPlatform): Promise<AppVersionInfo | null> {
  try {
    const { data, error } = await supabaseAnon
      .from('app_versions')
      .select('current_version, min_version, release_notes')
      .eq('platform', platform)
      .eq('is_active', true)
      .maybeSingle<AppVersionInfo>();

    if (error) {
      logger.warn('App version fetch failed:', error);
      return null;
    }

    if (!data) return null;

    return {
      current_version: data.current_version,
      min_version: data.min_version,
      release_notes: data.release_notes ?? null,
    };
  } catch (err) {
    logger.warn('App version fetch exception:', err);
    return null;
  }
}
